import React, { useEffect, useContext, useState } from 'react';
import { Field, WrappedFieldProps } from 'redux-form';
import { connect } from 'react-redux';
import { debounce, trim, get } from 'lodash';
import Preloader from '@omilia/preloader';

import FORM_NAMES from 'constants/formNames';
import TextFieldReduxWrapper from 'components/TextFieldReduxWrapper';
import FormWrapper, {
  FormContext,
} from 'scenes/Projects/scenes/CreateProjectModal/components/FormWrapper';
import { SAutoCompleteMenuWrapper } from 'components/styled';
import {
  getProjectsAll as getProjectsAllSelector,
  getProjectsWithNamesConcatedWithAccount,
  getIsLoadingAll,
  // @ts-ignore
} from 'store/services/projects/selectors';
import { PartialRootState } from 'store/services/projects/types';
// @ts-ignore
import { getProjectsAll, cloneProject } from 'store/services/projects/actions';

import {
  CloneProjectProps,
  FormValuesType,
  FormValuesTypeProjectParams,
  AccountTypeForm,
  ProjectTypeForm,
} from 'scenes/Projects/types';

import { cloneProjectValidate } from '../utils/validate';
import { SModalBodyWrapper } from '../../styled';

const renderAutocomplete = (props: WrappedFieldProps) => (
  <SAutoCompleteMenuWrapper {...props} />
);

const CloneProject = ({
  accounts,
  cloneProject,
  getAccounts,
  allProjects,
  onCloseRequest,
  isLoadingAccounts,
  isLoadingAllProjects,
  cancelGetAccounts,
  onSetProjectType,
  projectsCount,
  getProjectsAll,
  allProjectsWithUpdatedNames,
}: CloneProjectProps) => {
  const debouncedGetAccounts = debounce(getAccounts, 400);
  const { onChange, formValues } = useContext(FormContext);
  const [isSearching, setIsSearching] = useState(true);

  useEffect(() => {
    getProjectsAll();
    onSetProjectType('clone-project');
  }, [getProjectsAll, onSetProjectType]);

  const handleChangeValue = (value = '') => {
    if (projectsCount !== allProjects.length) {
      getProjectsAll({ name__icontains: value });
      setIsSearching(false);
    }
  };

  const handleSelectAccountItem = (item: AccountTypeForm) =>
    onChange('account', item);

  const handleSelectProjectItem = (item: ProjectTypeForm) =>
    onChange('project', item);

  const getAccountsCancelingPreviousRequest = (value = '') => {
    cancelGetAccounts();
    debouncedGetAccounts(value);
  };

  const handleSubmit = async ({ name, account, project }: FormValuesType) => {
    const {
      account: projectAccount,
      slug: projectSlug,
    }: FormValuesTypeProjectParams = project;

    await cloneProject(projectAccount, projectSlug, {
      name,
      account: account.slug,
    });

    onCloseRequest();
  };

  return (
    <SModalBodyWrapper>
      {isLoadingAllProjects && isSearching && (
        <Preloader showBackdrop data-test="preloader" />
      )}
      <FormWrapper
        form={FORM_NAMES.PROJECT.CLONE}
        submitBtnName="Clone"
        validate={cloneProjectValidate}
        onCloseRequest={onCloseRequest}
        onSubmitForm={handleSubmit}
      >
        <Field
          autoFocus
          component={TextFieldReduxWrapper}
          data-test="name"
          label="Project Name"
          name="name"
          normalize={trim}
          placeholder="Please type a name for the project"
          type="text"
        />

        <Field
          component={renderAutocomplete}
          data-test="account"
          isLoading={isLoadingAccounts}
          item={get(formValues, 'account.name', '')}
          items={accounts}
          label="Select Organization"
          name="account"
          placeholder="Select Organization"
          selectItem={handleSelectAccountItem}
          onChangeValue={getAccountsCancelingPreviousRequest}
          onOpen={getAccountsCancelingPreviousRequest}
        />

        <Field
          component={renderAutocomplete}
          data-test="project"
          isLoading={isLoadingAllProjects}
          item={get(formValues, 'project.name', '')}
          items={allProjectsWithUpdatedNames}
          label="Clone Project from"
          name="project"
          placeholder="Select Project"
          selectItem={handleSelectProjectItem}
          onChangeValue={handleChangeValue}
        />
      </FormWrapper>
    </SModalBodyWrapper>
  );
};

const mapStateToProps = (state: PartialRootState) => ({
  allProjects: getProjectsAllSelector(state),
  allProjectsWithUpdatedNames: getProjectsWithNamesConcatedWithAccount(state),
  isLoadingAllProjects: getIsLoadingAll(state),
});

export const mapDispatchToProps = {
  getProjectsAll,
  cloneProject,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CloneProject);
